import React, { useEffect, useState } from "react";
import { orgLogo } from "./OrganizationLogo";

export default function Logo() {
  const [showLogo, setShowLogo] = useState(true);
  const [imgSrc, setImageSrc] = useState(null);
  const handleImageError = (event) => {
    // event.target.src = "/Organization/Default/Logo.svg"; // Replace with  default image path
    setShowLogo(false);
  };

  useEffect(() => {
    const _imgSrc = orgLogo();
    setImageSrc(_imgSrc);
  }, []);

  return (
    <>
      {showLogo ? (
        <div className="logoDiv">
          <img onError={handleImageError} src={imgSrc} alt="not found" />
        </div>
      ) : (
        <>
          <div className="navbar-brand" style={{ paddingBottom: "0px" }}>
            <h4 className="prueLogoStyleCommon">PRÜFEXPRESS</h4>
          </div>
        </>
      )}
    </>
  );
}
